<ng-template [ngTemplateOutlet]="templateElement" [ngTemplateOutletContext]="{ $implicit: recht }"></ng-template>

<ng-template #default let-recht>
  {{ version.pfandrechtform + "_KURZ" | translate }},
  <span>{{ version | namenInhaberPfandrechtart }}</span>
  <ng-template [ngTemplateOutlet]="common"></ng-template>
</ng-template>

<ng-template #rechteId let-recht>
  @if (recht.rechteId) {
    {{ recht.rechteId | formatRechteId }},
  }
  {{ getAbkuerzungKey(version.pfandrechtform) | translate }},
  <span>{{ version | namenInhaberPfandrechtart }}</span>
  <ng-template [ngTemplateOutlet]="common"></ng-template>
</ng-template>

<ng-template #common>
  @if (version.pfandsumme > 0) {
    , CHF {{ version.pfandsumme | number: "1.0-2" : "de-CH" }}
  }
  @if (version.maximalzinsfuss) {
    {{ ", " + version.maximalzinsfuss + "%" }}
  }
  @if (version.maximalhypothek) {
    {{ ", " + "MH" | translate }}
  }
  @if (version.gesetzlichesPfandrecht) {
    {{ ", " }}{{ version.gesetzlichesPfandrecht?.text | translateName }}
  }
</ng-template>
